import React, { useCallback, useEffect, useState } from 'react';

import {
  CircularProgress,
  Paper,
  TableContainer,
  Table as TableUI,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core';
import { isNull } from 'lodash';
import PropTypes from 'prop-types';
import qs from 'querystring';

import { Hidden } from '~/components/Form';
import { t } from '~/helpers';
import { getToastErrors } from '~/helpers/errorsRequest';
import api from '~/services/api';

import { Input } from '..';

import * as S from './styles';

export default function Table({ tank, product, mirror, form, sent }) {
  const [loading, setLoading] = useState(false);
  const [beaks, setBeaks] = useState([]);
  const [options, setOptions] = useState([]);

  const handleRequestAPIBeaks = useCallback(async () => {
    try {
      setLoading(true);

      const { data } = await api.get('/bicos', {
        params: {
          wherefield: [
            'idposto',
            'idproduto',
            'habilitatrocatanque',
            'statusbico',
          ],
          valuewherefield: [tank, product, 1, 'L'],
          typewherefield: ['EQUALS', 'EQUALS', 'EQUALS', 'EQUALS'],
        },
        paramsSerializer: (value) => qs.stringify(value),
      });

      setBeaks(data.items);
    } catch (err) {
      getToastErrors(err);
    } finally {
      setLoading(false);
    }
  }, [tank, product]);

  const handleRequestAPIVirtualTanks = useCallback(async () => {
    try {
      setLoading(true);

      const { data } = await api.get('/tanquesvirtuais', {
        params: {
          wherefield: ['idposto', 'idproduto', 'statustanquevirtual'],
          valuewherefield: [tank, product, 'L'],
          typewherefield: ['EQUALS', 'EQUALS', 'EQUALS'],
        },
        paramsSerializer: (value) => qs.stringify(value),
      });

      const items = data.items.map((item) => ({
        value: item.idtanquevirtual,
        label: item.idtanquevirtual,
      }));

      setOptions(items);
    } catch (err) {
      getToastErrors(err);
    } finally {
      setLoading(false);
    }
  }, [tank, product]);

  const handleMirroring = useCallback(
    (data) => {
      if (mirror) {
        beaks.forEach((_, key) => {
          form.current.setFieldValue(`bicos.${key}`, data);
        });
      }
    },
    [mirror, beaks, form]
  );

  useEffect(() => {
    if (!isNull(tank) && !isNull(product)) {
      handleRequestAPIBeaks();
      handleRequestAPIVirtualTanks();
    }
  }, [tank, product]);

  useEffect(() => {
    if (sent) {
      handleRequestAPIBeaks();
      handleRequestAPIVirtualTanks();
    }
  }, [sent]);

  if (loading)
    return (
      <S.WrapperLoading>
        <CircularProgress size={30} />
      </S.WrapperLoading>
    );

  return (
    <Paper style={{ marginTop: '1rem' }}>
      <TableContainer>
        <TableUI size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t('s.configuracao.bico.idbico')}</TableCell>
              <TableCell>{t('s.geral.camposistema.idtanquevirtual')}</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {beaks.map((beak, key) => (
              <TableRow key={beak.rownum}>
                <TableCell>{beak.idbico}</TableCell>
                <TableCell>{beak.idtanquevirtual}</TableCell>
                <TableCell>
                  <Input
                    name={`bicos.${key}`}
                    label={t('s.configuracao.bico.idtanquevirtual')}
                    options={options}
                    onChange={({ target }) => handleMirroring(target.value)}
                  />

                  <Hidden name={`ids.${key}`} defaultValue={beak.idbico} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </TableUI>
      </TableContainer>
    </Paper>
  );
}

Table.propTypes = {
  tank: PropTypes.string,
  product: PropTypes.string,
  mirror: PropTypes.bool,
  form: PropTypes.objectOf(PropTypes.any).isRequired,
  sent: PropTypes.bool.isRequired,
};

Table.defaultProps = {
  tank: null,
  product: null,
  mirror: true,
};
